import { metricKeys } from '@pulse/metrics';
import { ALL_TRAFFIC } from '@utils/filter';
import { createAiAlertsPreset } from './presetCreator/ECO/createAIAlertsPreset';
import { SUMMARY_PANEL_TYPE } from '@src/components/top-widget-panel/constants';
import { ECO_PRESET_KEY } from '../limitation';

export const appPresetKeys = ECO_PRESET_KEY;

export const ecoServerPresetKeys = {};

export const miniODPPresetKeys = {};

export const appPresetTitles = {
  [appPresetKeys.APP_EVENTS]: 'Events',
  [appPresetKeys.APP_NETWORK_PERFORMANCE]: 'Server Side Performance',
  [appPresetKeys.APP_USER_EXPERIENCE]: 'User Experience',
};

export const getAppEventsPreset = ({ validateMetric, validateDimension }) => {
  return {
    title: 'Events',
    key: ECO_PRESET_KEY.APP_EVENTS,
    description: 'Track App Events (system and user generated).',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.AppSubscribers),
        metrics: validateMetric([
          metricKeys.AppTotalEvents,
          metricKeys.AppTotalUserEvents,
          metricKeys.AppSubscribers,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'event_name',
            'device_name',
            'application_version',
            'page_urlpath',
            'tag_key',
            'tag_value',
          ]),
        },
      },
    },
  };
};

export const getServerSidePerformancePreset = ({ validateMetric, validateDimension }) => {
  return {
    title: 'Server Side Performance',
    key: ECO_PRESET_KEY.APP_NETWORK_PERFORMANCE,
    description:
      'Examine network requests and response durations to monitor the performance of the server side.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.AverageRequestDuration),
        metrics: validateMetric([
          metricKeys.AverageRequestCount,
          metricKeys.AverageRequestDuration,
          metricKeys.AppSubscribers,
          metricKeys.FailedNetworkRequest,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'network_request_response_code',
            'network_request_url_host',
            'network_request_url_path',
            'page_title',
            'screen_title',
            'device_name',
            'application_version',
          ]),
          globalOrderBy: validateMetric(metricKeys.AverageRequestCount),
          dimensionMetrics: validateMetric([
            metricKeys.AverageRequestCount,
            metricKeys.AverageRequestDuration,
            metricKeys.FailedNetworkRequest,
          ]),
        },
      },
      summaryWidgets: {
        type: SUMMARY_PANEL_TYPE.NETWORK,
        widgets: [],
      },
    },
  };
};

export const getUserExperiencePreset = ({ validateMetric, validateDimension }) => {
  return {
    title: 'User Experience',
    key: ECO_PRESET_KEY.APP_USER_EXPERIENCE,
    description: 'Analyze App Performance and User Experience.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.AppSubscribers),
        metrics: validateMetric([
          metricKeys.AppSubscribers,
          metricKeys.AppAvgPageLoadTime,
          metricKeys.AppAvgScreenLoadTime,
          metricKeys.AppStartupTime,
          metricKeys.AppCrashSessions,
          metricKeys.AppServicePerformanceIndex,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'device_name',
            'application_version',
            'page_urlpath',
            'geo_country',
            'app_id',
          ]),
        },
      },
    },
  };
};

export const genAppUsecases = ({ validateMetric, validateDimension, aiAlertsSensitivities }) => [
  getUserExperiencePreset({ validateMetric, validateDimension }),
  getServerSidePerformancePreset({ validateMetric, validateDimension }),
  getAppEventsPreset({ validateMetric, validateDimension }),
  // createAiAlertsPreset({ validateMetric, validateDimension, aiAlertsSensitivities }),
];
